import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { LockIcon } from 'lucide-react';
import { TopBar } from '../components/TopBar';
interface ChangePINProps {
  navigate: (screen: string) => void;
}
export function ChangePIN({
  navigate
}: ChangePINProps) {
  const [isSaving, setIsSaving] = useState(false);
  const handleSave = () => {
    setIsSaving(true);
    setTimeout(() => {
      setIsSaving(false);
      navigate('profile');
    }, 1000);
  };
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} className="flex-1 overflow-y-auto pb-safe bg-slate-50" data-id="element-1179">
      <TopBar title="Change PIN" showBack onBack={() => navigate('profile')} data-id="element-1180" />

      <div className="px-5 pt-6 pb-8" data-id="element-1181">
        <div className="flex flex-col items-center mb-8 text-center" data-id="element-1182">
          <div className="w-16 h-16 rounded-full bg-amber-50 text-amber-500 flex items-center justify-center mb-4" data-id="element-1183">
            <LockIcon className="w-8 h-8" data-id="element-1184" />
          </div>
          <h2 className="text-xl font-bold text-[#0D3B3B] mb-2" data-id="element-1185">
            Update Security PIN
          </h2>
          <p className="text-sm text-gray-500" data-id="element-1186">
            Your PIN is used to authorize transactions and access sensitive
            information.
          </p>
        </div>

        <div className="space-y-4 mb-8" data-id="element-1187">
          <div className="space-y-1.5" data-id="element-1188">
            <label className="text-xs font-bold text-gray-500 uppercase tracking-wider ml-1" data-id="element-1189">
              Current PIN
            </label>
            <input type="password" placeholder="••••" maxLength={4} className="w-full bg-white border border-gray-200 rounded-2xl py-3.5 px-4 text-center tracking-[1em] text-lg font-black text-[#0D3B3B] focus:outline-none focus:ring-2 focus:ring-[#2BA89D]/20 focus:border-[#2BA89D] transition-all" data-id="element-1190" />
          </div>

          <div className="space-y-1.5" data-id="element-1191">
            <label className="text-xs font-bold text-gray-500 uppercase tracking-wider ml-1" data-id="element-1192">
              New PIN
            </label>
            <input type="password" placeholder="••••" maxLength={4} className="w-full bg-white border border-gray-200 rounded-2xl py-3.5 px-4 text-center tracking-[1em] text-lg font-black text-[#0D3B3B] focus:outline-none focus:ring-2 focus:ring-[#2BA89D]/20 focus:border-[#2BA89D] transition-all" data-id="element-1193" />
          </div>

          <div className="space-y-1.5" data-id="element-1194">
            <label className="text-xs font-bold text-gray-500 uppercase tracking-wider ml-1" data-id="element-1195">
              Confirm New PIN
            </label>
            <input type="password" placeholder="••••" maxLength={4} className="w-full bg-white border border-gray-200 rounded-2xl py-3.5 px-4 text-center tracking-[1em] text-lg font-black text-[#0D3B3B] focus:outline-none focus:ring-2 focus:ring-[#2BA89D]/20 focus:border-[#2BA89D] transition-all" data-id="element-1196" />
          </div>
        </div>

        <button onClick={handleSave} disabled={isSaving} className="w-full bg-[#0D3B3B] hover:bg-[#092D2D] text-[#FFD700] font-bold py-4 rounded-xl transition-all shadow-lg shadow-[#0D3B3B]/20 active:scale-95 text-lg flex justify-center items-center" data-id="element-1197">
          {isSaving ? <div className="w-6 h-6 border-2 border-[#FFD700]/30 border-t-[#FFD700] rounded-full animate-spin" data-id="element-1198" /> : 'Update PIN'}
        </button>
      </div>
    </motion.div>;
}